import React from "react";
import * as Icons from "lucide-react";
import { pains } from "../data";

export default function Pains() {
  return (
    <section className="pains" id="pains">
      <div className="container">
        <div className="section-label">Знакомые опасения</div>
        <h2 className="section-title">Понимаем, почему вы откладываете визит к стоматологу</h2>
        <p className="section-subtitle">
          Мы знаем о ваших страхах и сделали клинику такой, чтобы их не было. Разберём по порядку.
        </p>

        <div className="pains-grid">
          {pains.map((p) => {
            const Icon = Icons[p.icon] || Icons.AlertCircle;
            return (
              <div key={p.title} className="pain-card" data-testid={`pain-${p.icon}`}>
                <div className="pain-icon">
                  <Icon size={24} strokeWidth={1.8} />
                </div>
                <div className="pain-title">{p.title}</div>
                <p className="pain-text">{p.text}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
